const data =  [
  {
    name: '公司战略',
    answer: [
      {
        question:'公司近年来新建项目较多，请问公司上半年在建工程主要布局哪些方面？ ',
        right:`公司2021年上半年在建工程约91亿元，较年初52.95亿元增长38.07亿元，主要围绕新材料业务展开，系本期碳三一期、芳纶、环氧树脂等项目增加所致。
        上半年，碳三一期项目ECH钢结构施工基本结束、启动设备安装，酚酮、BPA、PDH推进土建和桩基施工；芳纶项目经调试产能消耗达设计指标，上半年累计产量1000吨以上，月平均合格率近80%；环氧树脂项目推进土建和桩基施工，预计年底能够建成。`,
      },
      {
        question:'请问公司如何进行碳达峰与碳中和工作？公司提倡的ESG可持续发展跟总书记提倡的碳中和有关系吗？',
        right:'尊敬的投资者您好，感谢您的提问。气候变化和碳减排一直中化国际关注的重要ESG议题。早在2019 年，公司就发起“FINE 2030 倡议”，制定了包括碳减排在内的2030年可持续发展目标。2020年，通过持续完善能源管理体系、升级改造各类老旧设备、开展企业节能评估、优化能源使用方式等措施，中化国际总体碳排放量相对2019年减少22万吨。我们也将抓紧制定2030年前碳排放达峰行动方案，加强前瞻性研究和战略布局，进一步推进能源结构清洁低碳化，加强全过程节能管理，加强新一代清洁高效可循环生产工艺、节能减碳技术研发创新，积极开发绿色化学产品，努力实现从能源资源生产到化学产品制造等各个环节的低碳化。感谢您对公司的关注。'
      },
      {
        question:'两化合并后，中化国际的主营业务是否有变更？今年来中化国际的投资比较多，新的业务何时进入成长期与利润增长点？',
        right:`尊敬的投资者您好，感谢您的提问。公司聚焦以化工新材料为核心的精细化工主业，实施创新驱动战略，优化升级高性能材料及中间体、聚合物添加剂等化工新材料业务，大力发展锂电池、锂电池材料等新能源业务。公司将依托连云港循环经济产业园和自主突破的关键技术，打造产业结构合理、产品组合丰富的创新型的精细化工领先企业。
        公司新业务方面，对位芳纶项目处于调试期，产量稳步提升，主要应用于电子通讯、汽车轻量化、人体防护等领域；连云港产业园碳三产业一期项目目前进展顺利，在建包括年产60万吨PDH、65万吨苯酚丙酮、24万吨双酚A、40万吨PO和15万吨ECH生产装置及相关公辅工程设施，计划2022年6月底前建成投产。感谢您对公司的关注。`
      },
      {
        question:'近期两化联合重组很受市场关注，对中化国际有何战略意义？',
        right:`“新中化”即中国中化的成立对中化国际的发展是利好的。两化联合重组完成后，中国中化业务范围覆盖生命科学、材料科学、基础化工、环境科学、橡胶轮胎、机械装备、城市运营、产业金融等八大领域，是全球规模最大的综合性化工企业。
        中化国际作为中国中化旗下优质的材料平台，具有承担相关产业国家使命的战略地位。根据产业链相关设计原则，两化内部大量进行协同和资产调整的布局，是未来可以期待的。`
      },
      {
        question:'公司汽车相关业务有哪些？占比多少？',
        right:'尊敬的投资者您好，感谢您的提问。公司聚合物添加剂、ABS以及天然橡胶等业务与汽车行业相关，具体业务情况分析请参见公司定期报告。感谢您对公司的关注。'
      },
      
      {
        question:'请问是否能简单介绍一下，贵司在产属于进口替代的卡脖子产品有哪些？',
        right:'尊敬的投资者您好，感谢您的提问。公司投资的对位芳纶与反渗透膜等产品属于进口替代的卡脖子类产品。感谢您对公司的关注。',
      },
      {
        question:'请问公司的连云港循环经济产业园项目是如何做到循环产业链的？刘红生总经理提到的建成最具特色的产业园区对标巴斯夫等国际巨头优势在哪里？ ',
        right:'尊敬的投资者您好，感谢您的提问。中化连云港循环经济产业园项目充分考虑了反应热梯次利用，副产物深加工或再循环；深度挖掘碳、氢、氯等资源的平衡与产业价值，做到能量与资源的充分循环利用。相比于国内同期建设的一体化产业基地，差异化的产品结构，自有绿色工艺（环氧丙烷、环氧氯丙烷等）以及与周边产业的协同是该项目的主要优势。',
      },
      {
        question:'公司近年来投入这么多产业项目，请问公司是如何定位自身经营业务？是否存在剥离贸易板块转型实业生产制造的可能？ ',
        right:'尊敬的投资者您好，感谢您的提问。“跻身头部、打造科技驱动的创新型精细化工企业”是中化国际矢志不移推进的目标。随着战略转型的持续推进，公司进一步聚焦新材料、新能源，已逐步形成了覆盖高分子聚合材料、聚合物添加剂、锂电池等相关产业。感谢您对公司的关注。',
      },

      {
        question:'请问扬农集团出售了扬农化工这一核心资产后，还有什么盈利能力强的资产？',
        right:`尊敬的投资者您好，感谢您的提问。扬农集团主营业务为基础化学品、精细与专用化学品、新材料、电子化学品的研发、生产和销售，主要产品包括氯碱化工、芳香烃氯化硝化加氢、生物基环氧树脂、芳纶特种纤维、电子化学品等五大主导产品系列，广泛应用汽车、航空航天、5G、集成电路、农药、医药、涂料染料等领域。目前已具有显著的差异化综合比较竞争优势，其中：生物法环氧氯丙烷和环氧树脂等一体化产业链技术经济和资源综合利用水平行业领先；对位芳纶规模、产品质量和清洁生产水平国内第一；氯苯、硝基氯苯和一氯二氯等系列产品的技术、规模和安全环保水平全球领先，并拥有向下游延伸发展材料及高端精细与专用化学品的产业基础和成长空间。
        此外，扬农集团下属的江苏瑞恒新材料C3产业一期项目总投资139.13亿元，计划2022年6月底前建成投产，项目投产后预计年均销售收入110.11亿元、年均`
      }
    ],
  },

  {
    name: '公司业绩',
    answer: [
      {
        question:'公司2021半年报显示，上半年公司的营收、净利增幅很大，能否详细说明一下各指标增长的原因？',
        right:'公司上半年实现营业收入约388.9亿（同比上升56.8%），归属于上市公司股东的扣除非经常性损益的净利润约6.09亿（去年同期为-0.62亿），主要得益于前期战略投入和高效稳定运营。2021年上半年，国内疫情总体平稳、经济有序运行，下游需求持续向好。中化国际依靠自身在化工领域的多年积淀，稳定生产运营，灵活制定销售策略，抢抓机遇，把握住了化工品上行周期的有利时机，实现盈利水平的快速提升。',
      },
      {
        question:'公司2021上半年的经营业绩非常好，下半年的扣非利润是否可持续？',
        right:'下半年公司将继续推进“打造科技创新驱动的，以化工新材料为核心的领先精细化工企业”的长期目标，积极克服疫情、极端天气等不利影响，持续推进重点战略项目，确保项目投资按计划推进。同时，通过新产品增长、多样化销售抢抓机遇、降本减费等多项经营举措，抵御环境及政策风险，促进主营业务增长，助力长期战略达成。'
      },
      {
        question:'公司目前投资在建项目较多，资金需求大，资源整合需要资金量也比较多，目前有没有再融资计划？或者有没有发行可转债的可能？公司怎样看待目前的高负债率？',
        right:`首先，公司处于战略实施的关键期，会持续加大在项目建设上的投资。公司资产负债率在投资建设期略有上升是符合行业规律的。我们会非常谨慎、非常主动地管理资本结构，确保公司的资产负债率维持在一个健康的、风险可控的水平。
        其次，公司融资能力非常强。公司目前拥有近700亿的授信，仅使用了153亿左右，使用率约为25%，还有近75%的银行授信尚未使用。今年公司也择机开展了公司债、永续债等直接融资，发行成本基本上都是资本市场同期同类企业里的最低水平，可以看出中化国际融资能力非常强且非常有保障。
        同时，公司根据资本市场的实际情况以及投资项目的进展不断做长期资本结构规划的修订和敏感性的测试。公司持续优化调整分红政策，遵循先“内部融资”后“外部融资”的原则，统筹考虑包括股权和债券的融资方案，长期债务和短期债务融资比例，也包括定增、配股、可转债、永续债这些产品选择，从而确保公司资本结构的稳健。`
      },
      {
        question:'根据公告，公司在进行扬农集团股权交易的过渡期间产生了7亿多的净利润。请问这些利润是否计入公司2021半年报？',
        right:'尊敬的投资者您好，感谢您的提问。过渡期是自2020年10月1日至2021年6月30日止9个月期间，扬农集团实现的归属于母公司股东的净利润已按上市公司对扬农集团的持股比例在所属的会计期间体现。感谢您对公司的关注。'
      },
      {
        question:'最近公司部分管理层在二级市场增持公司股票，请问公司有没有进一步进行股权激励的计划？',
        right:`本次管理层二级市场增持反映了公司管理层对于公司未来持续发展的信心以及对公司价值的认同。公司在现有高性能材料及中间体、聚合物添加剂等“现金牛”存量业务的基础上，随着碳三一期、环氧树脂、芳纶、促进剂等新项目陆续建成投产，中化国际的增量业务将陆续提供新的利润贡献，我们作为公司管理层，对公司重点战略项目的落地充满信心，因此通过本次增持公司股票的举动向资本市场正向传递我们的信心。
        公司在2019年第一次实施限制性股票激励计划，在去年非常困难的情况下，对公司完成全年业绩有非常好的牵引作用。公司希望在未来有更多的股权激励措施，让更多员工参与进来，具体情况如有进展，公司将根据相关法律法规及时履行信息披露义务。`
      },
    ]
  },

  {
    name:'研发创新',
    answer:[
      {
        question:'公司2021上半年研发投了5亿，主要用于哪些方面？目前公司创新平台有哪些？',
        right:`公司上半年研发投入主要投向新材料及新能源两大方向。新材料方面主要投向扬农集团化工中间体及高性能材料业务方面；新能源则围绕锂电池及电池材料等产业链展开。
        目前公司在上海总部张江园区、扬农集团、高性能材料事业部、圣奥化学、新能源事业部等下属单位均有不同领域的创新平台，研发领域包括化工中间体、芳纶、添加剂、锂电池等。`
      },
      {
        question:'能否介绍一下公司在科技创新方面的主要方向，包括重点项目、产品和技术储备？',
        right:`科技创新是中化国际的DNA，坚持科技引领和绿色发展是中化国际高度重视的两大战略指引方向。
        从科技创新投入来看，我们的科技投入水平已占产业收入的4.8%，未来我们会坚持这样高水平的资金投入；从构建科技体系来看，我们希望围绕某一个产品来进行技术积累和持续的产品链开发；从打造科研平台来看，我们依托总部创新中心（中化科技）和各BU自有的科技创新平台进行科技投入，鼓励芳纶等重点项目建立自己的科研所，保证足够强度和频率的科研。
        从科技创新方向来看，目前我们70%的科研精力放在主营业务上，通过持续研发投入和科研人才机制优化，不断加强主营业务核心竞争力；20%用于共性关键技术的研究，通过高效、经济的总部共享技术平台和综合性科研人才，为各个业务单元服务；10%用于前瞻性技术的研究，包括特种尼龙等特种材料，该方向将涉及到未来中化国际三到五年的长远投入，到一定阶段公司会根据相关法律法规及时履行信息披露义务。`
      },
      {
        question:'2020年公司半年报披露，面对行业困境，2020 年上半年公司逆势加大研发费用投入 3.8 亿元，请问公司研发投入主要体现在哪些方面？',
        right:'尊敬的投资者您好，感谢您的提问。公司研发投入侧重于应用技术研发，在持续加大重点研发项目攻关力度的同时，提升应用技术及工艺水平，使研发成果持续高效转化为现有核心产品的生产能力，促进中长期销售提升。感谢您对公司的关注。'
      },
      {
        question:'科学至上是两化的口号，请问中化国际在科技创新方面有哪些核弹级的项目与产品或技术储备？',
        right:'尊敬的投资者您好，感谢您的提问。在科技创新方面，公司芳纶项目已经进入产业化阶段，锂电产品也在全产业链发展。下一步公司将着重打造“高通量”创新机器，兼顾近期与远期产业需求，在特种尼龙、电子化学品、聚酰亚胺等产品领域进行储备。感谢您对公司的关注。'
      }
    ]
  },

  {
    name:'连云港产业园',
    answer:[
      {
        question:'公司如何看待连云港产业园项目？基地一体化是否会成为精细化工的未来趋势？',
        right:`公司聚焦以化工新材料为核心的精细化工主业，依托连云港循环经济产业园和自主突破的关键技术，打造产业结构合理、产品组合丰富的创新型的精细化工领先企业。
        国家政策对环保和安全的要求不断趋严，“碳达峰、碳中和”的国家战略不断推进，基地一体化是未来化工企业实现高质量发展的必然趋势。我国化工品种类纷繁，园区化、基地一体化是加速淘汰化工落后产能的有效手段，未来化工行业集中度将大幅提升；基地一体化可实现产业上下游的有效协同，打造产业链一体化，大幅降低生产成本，形成成本优势和规模经济，提升企业的盈利能力；基地一体化可实现更规范的统筹管理，对企业的环保、安全、碳排放等方面进行更有效的监控和管理，环保事故率下降，安全保障增强；化工用地审批难度加大，化工园区和基地具备自然资源的稀缺属性，未来价值倍增。国内领先化工企业普遍致力于打造基地一体化，发挥基地一体化的优势。
        中化国际顺应发展趋势，持续加强一体化产业基地建设，实现集约化发展，打造以连云港基地为核心，中卫、仪征、盐城滨海等多个特色基地共同发展的新格局。`
      },
      {
        question:'碳三项目的进展及计划投产时间如何？规划年产能产值是多少？',
        right:`公司碳三产业一期项目工程总投资金额人民币139.13亿元，在建包括年产60万吨PDH、65万吨苯酚丙酮、24万吨双酚A、40万吨PO和15万吨ECH生产装置及相关公辅工程设施。
        2021上半年，碳三一期项目ECH钢结构施工基本结束、启动设备安装，酚酮、BPA、PDH推进土建和桩基施工；部分项目（如ECH等）将于2021年先期投产，计划2022年全面建成投产。
        根据公司公告，项目投产后可贡献年均销售收入约110亿元。`
      },
      {
        question:'请问公司环氧氯丙烷项目现在什么情况？',
        right:'尊敬的投资者您好，感谢您的提问。根据碳三产业链一期项目投产进度，15 万吨/年 ECH（环氧氯丙烷）项目预计2021 年底前投料试车。'
      },
      {
        question:'公司15万吨/年双氧水法环氧氯丙烷技术的优势有哪些？',
        right:'扬农集团自主研发的双氧水法ECH创新工艺反应条件温和、工艺流程短，不产生难处理的含盐废水，具有显著成本竞争力和清洁环保优势，较传统工艺优势明显。依托双氧水法工艺技术突破、C3产业链配套的原料丙烯和双氧水资源，自建15万吨双氧水法产能，与甘油法产能形成互补。'
      },
      {
        question:'请问环氧丙烷40万吨产能项目进展如何？',
        right:'尊敬的投资者您好，感谢您的提问。根据碳三产业链一期项目投产进度，目前40万吨/年环氧丙烷项目处于建设中，预计2022年建成投产。感谢您对公司的关注。'
      },
      {
        question:'2021年连云港产业园碳三项目将有部分投产，聚合物添加剂项目预计在明年投产，请具体介绍一下这两个项目的竞争优势',
        right:`第一，连云港碳三项目是按照园区一体化原则建设的，实现了高度一体化和副产品的综合利用。碳三产业链始于丙烷脱氢和烧碱，在构建产品结构时我们充分利用氢气、钠离子等副产物，体现循环经济的理念，实现高效的资源综合利用。
        第二，碳三和聚合物添加剂项目采用了自主研发、具有知识产权的绿色工艺，具备成本竞争力，能够大幅降低能耗物耗和三废排放水平，形成HSE核心竞争力。
        第三，公司已经深耕碳三产业链和聚合物添加剂业务领域多年，拥有丰富的产业运营基础、客户资源和市场渠道，新中化成立以后我们的产品也将在内部协同中发挥作用。
        此外，聚合物添加剂项目对中化国际非常重要，它是新中化唯一的添加剂平台，未来更将服务于整个中国化工业，我们希望将项目打造成全球最有竞争力的添加剂平台。`
      },
      {
        question:'连云港产业园PDH装置下游中化国际拥有很多自有技术，相比其他企业是否更有优势往下游扩张？公司未来是否会延续这样的发展思路：比起扩规模，更重视下游高附加值产品的投入？',
        right:`第一，在构建连云港产业产品结构时，公司的目标是打造技术领先的企业，产品可以体现出技术的先进性，因此构建连云港循环经济产业是以技术为基础，没有技术创新，我们不会做大的投入。
        第二，从连云港循环经济产业结构来看，公司充分考虑了不同产品受到经济周期的影响程度，如双酚A，相对来说会受到一定经济周期的影响，而聚合物添加剂是一个弱经济周期的产品。
        第三，连云港产业园统筹兼顾了包括新中化、园区在内的各项资源，充分发挥一体化协同优势，利用好各项资源，与公司自身能力能够相匹配，为公司的发展打造良好的基础。
        第四，对于未来的产业产品结构拓展，除目前的碳三资源外，是否可以在未来加入碳四等资源，公司会充分考虑这些因素，将其纳入到未来的结构调整过程中。`
      },
      {
        question:'目前双酚A的价格非常理想，公司48万吨的双酚A项目选得非常好，现在项目进度如何，是否可以提前投产？',
        right:`公司在碳三产业中规划了首套24万吨的双酚A项目，后续将建设24万吨的双酚A项目，总产能48万吨。
        按照先前的进程，整个碳三产品系列原计划于2022年6月份建成投产。从目前实际情况来看，我们计划将各个项目分期投产，24万吨的双酚A项目将会在今年年底前建成中交，投产会安排在明年一季度。第二套24万吨双酚A项目相对会滞后两三个月，将逐步对市场进行投放。`
      },
      {
        question:'请问公司的连云港循环经济产业园项目是如何做到循环产业链的？刘红生总经理提到的建成最具特色的产业园区对标巴斯夫等国际巨头优势在哪里？ ',
        right:'尊敬的投资者您好，感谢您的提问。中化连云港循环经济产业园项目充分考虑了反应热梯次利用，副产物深加工或再循环；深度挖掘碳、氢、氯等资源的平衡与产业价值，做到能量与资源的充分循环利用。相比于国内同期建设的一体化产业基地，差异化的产品结构，自有绿色工艺（环氧丙烷、环氧氯丙烷等）以及与周边产业的协同是该项目的主要优势。'
      },

      {
        question:'公司连云港产业园项目投资超过300亿，具体规划了哪些项目？都是中化国际的项目吗？ ',
        right:'尊敬的投资者您好，感谢您的提问。中化连云港循环经济产业园目前规划了碳三项目、瑞恒化工中间体项目、圣奥聚合物添加剂一期项目、电子化学品项目以及罐区项目等，均为中化国际及下属子公司的项目。具体情况请以公司公告为准。感谢您对公司的关注。'
      },
      {
        question:'公司连云港产业园主要工程项目建设进展如何? ',
        right:'尊敬的投资者您好，感谢您的提问。连云港循环经济产业园区瑞恒一期A阶段项目已完成建设并投产，产品产量、质量、消耗均达到设计要求，生产正常，一期B阶段项目正在紧张施工中；碳三项目与罐区项目正在设计中。感谢您对公司的关注。'
      }
    ]
  },

  {
    name:'锂电池与正极材料',
    answer:[
      {
        question:'公司的锂电池产品开始量产供货了吗？',
        right:'公司淮安骏盛锂电池项目处于量产爬坡阶段，目前全线设备已经完成联机调试，已具备量产供货能力。客户送样正在稳步推进中。公司正积极与各类车企客户进行对接，逐步建立稳定的供应伙伴关系。'
      },
      {
        question:'公司在扬州的锂电池生产是否恢复了正常生产，经营情况怎么样？',
        right:'尊敬的投资者您好，感谢您的提问。公司扬州锂电基地已经全面复工，推进设备进场工作。'
      },
      {
        question:'公司扬州锂电池是否通过汽车企业验收？什么时候可量产？',
        right:'尊敬的投资者您好，感谢您的提问。公司扬州锂电首期项目处于建设中，目前正在克服前期疫情影响，推动设备进场安装工作，预计2022年3月具备量产能力。感谢您对公司的关注。'
      },
      {
        question:'宁夏中化锂电池材料是否已经达产？销售是否顺畅？实现满负荷生产了吗？',
        right:'宁夏中化锂电池材料公司目前的主要产品是5系和8系NCM三元正极材料，已批量供应国内主流动力、小动力和3C数码客户，目前已实现满负荷生产，公司运营情况良好，随着下游客户需求的迅速增长，公司正在积极研究产能提升计划。'
      },
      {
        question:'请问公司有没有储能业务，能否详细介绍一下？',
        right:'尊敬的投资者您好，感谢您的提问。公司储能业务正在规划布局中。感谢您对公司的关注。'
      },
      {
        question:'请问公司与宝马合作的锂电项目相关情况，产能规模如何？目前进度情况如何？预计正式投产交货时间大概什么时候？',
        right:'尊敬的投资者您好，感谢您的提问。扬州锂电项目产能规模将配合客户的实际需求，按需建设，目前首期项目已进入内装工程阶段，主要设备合同已经签订完成，预计2022年3月建成并具备可量产能力。感谢您对公司的关注。'
      },


      {
        question:'公司锂电池研发团队建设如何？是否有具体的研发方向和研发成果？',
        right:'尊敬的投资者您好，感谢您的提问。公司新能源研发团队建设采用“外部引入+内部培养”相结合的形式，团队已形成一定的规模，目前团队已具备了电芯-模组-电池包的产品开发能力。感谢您对公司的关注。'
      },
      {
        question:'公司淮安骏盛锂电池项目最新进展及认证情况如何？ ',
        right:'尊敬的投资者您好，感谢您的提问。淮安锂电池项目进展顺利，已进入到客户送样认证阶段，当前产品性能较之行业同类型产品具备一定的性能优势。根据行业规范，认证需要一定周期及要求，感谢您对公司的关注。'
      },
      {
        question:'公司扬州的电池项目何时开建? ',
        right:'尊敬的投资者您好，感谢您的提问。新能源扬州项目于2020年12月底开工建设。感谢您对公司的关注。'
      },
      {
        question:'能否介绍一下公司新能源相关业务情况及发展方向？ ',
        right:'尊敬的投资者您好，感谢您的提问。公司新能源业务以动力电池研发与制造为核心，当前在淮安、扬州两地打造生产基地，发挥产业链上下游协同优势。具体的业务拓展计划请以公司公告为准。感谢您对公司的关注。'
      },
      {
        question:'公司宁夏中卫正极材料项目进展如何？',
        right:'尊敬的投资者您好，感谢您的提问。宁夏中卫正极材料项目已建成10000吨NCM产能，正按计划推进客户开发和产品测试认证。'
      }
    ]
  },

  {
    name:'高性能材料',
    answer:[
      {
        question:'公司的芳纶项目2020年四季度已投料试车，请问目前是否已经达产？实现满负荷生产和正常销售了吗？',
        right:'公司5000吨/年对位芳纶项目已于2020年四季度成功投料试车，并产出合格产品。今年上半年处于调试期，生产调试线状态良好，上半年实现产量1000吨以上，产品顺利投放市场并得到客户认可，并在下游产品开发和应用测试领域得到权威机构检测认证，主要应用于电子通讯、汽车轻量化、人体防护等领域。'
      },
      {
        question:'公司的芳纶业务在技术上有很强的壁垒，请问技术优势体现在何处？能否解读一下芳纶产品的竞争格局以及未来的前景？',
        right:`芳纶项目从材料属性上来讲是非常不错的产品，但它在建设上的技术难度很大，难点并不在专利方面，而是在实用技术方面。
        我们的优势主要体现在：一是从生产技术角度来看，我们的自动化水平很高，所以劳动生产率比较高；此外芳纶项目在能耗指标方面有一定要求，经过这一轮调试，项目能耗大幅下降，体现出了竞争力。
        第二，从下游应用来看，芳纶要跟下游的应用和技术的营销紧密相联系，在这方面我们做了很多工作：在下游的延伸上我们正在补强，一些补强的项目将会在今年年底建成；在复合材料的下游应用上我们也做了很多开拓尝试，比方说在膜的应用技术上，目前RO膜、超滤膜在中国的市场应用很广泛，我们在这些领域协同下游单位共同研究，目前取得了较好的效果。
        第三，目前国内芳纶以进口为主，我国对位芳纶年需求约1.3万吨，而且近年来需求量保持高速增长，远超全球平均水平，市场空间很大。国内的产能和市场的需求是不匹配的，特别是在高端领域尤为不匹配，国内市场在高强度纺丝方面还需努力，国家对此非常重视，我们希望在这一领域能够对国家做出贡献。`
      },

      {
        question:'公司半年报说5000吨芳纶项目“有望填补国内空白、打破国外垄断”怎么理解呢？ ',
        right:'尊敬的投资者您好，感谢您的提问。目前国内每年仍有近80%左右的对位芳纶是进口杜邦、帝人等产品，特别是在高强和高模产品领域。中化国际5000吨对位芳纶项目投产后将实现本土化大规模量产，且具有普通、高强和高模产品组合，能实现部分进口产品的替代。感谢您对公司的关注。'
      },
      {
        question:'公司对位芳纶中试的500吨产能现在是满产满销吗？这次的5000吨产能和中试的500吨产能有区别吗？这个项目是扬农集团的吗？中化国际有多少股份？ ',
        right:'尊敬的投资者您好，感谢您的提问。公司年产5000吨芳纶项目已完成中交，进行设备调试，已于2020年12月进行投料试车。500吨芳纶中试项目生产产品根据规格不同分为粗旦丝、细旦丝，目前已实现满产满销。年产5000吨芳纶项目是新建设的产线，设计产能为5000吨/年，不包括500吨中试项目产能。该项目为中化高性能纤维材料有限公司（简称“中化高纤”）新建项目，江苏瑞盛新材料科技有限公司（简称“江苏瑞盛”）持有中化高纤85%股权，扬农集团和中化国际分别持有江苏瑞盛60%和40%股权，中化国际享受中化高纤权益股比约54.4%。感谢您对公司的关注。'
      },

      {
        question:'请问一下公司的高性能聚烯烃树脂进展到什么阶段了？距离量产还需要多久时间？请详细介绍一下未来前景怎么样？',
        right:'尊敬的投资者您好，感谢您的提问。公司聚烯烃树脂项目进展顺利，目前处于客户送样测试认证阶段。聚烯烃树脂在成本、固废处理、性能方面有独特的优势，在多个行业有着巨大的应用潜力。感谢您对公司的关注。'
      },
      {
        question:'公司的膜产业进展如何？预计何时能试生产？',
        right:'尊敬的投资者您好，感谢您的提问。目前反渗透膜项目正处于建设期，卷膜线2020年底投入试生产，制膜及涂膜线预计2021年上半年投入试生产。感谢您对公司的关注。'
      }
    ]
  },
  {
    name:'聚合物添加剂',
    answer:[
      {
        question:'公司的聚合物添加剂业务作为新中化唯一的添加剂平台，有哪些差异化优势？',
        right:`公司添加剂业务差异化优势体现在以下几个方面：
        （1）防老剂：添加剂事业部多年深耕橡胶助剂行业，通过多年来的发展与积累，已处于防老剂行业领先地位，在技术开发、成本下降、客户关系等方面集聚了成熟优势。防老剂产品工艺全球领先，RT培司生产工艺获国家科技进步二等奖，6PPD生产工艺获国家技术发明二等奖，三废“0”排放，长期与知名轮胎厂商保持合作。
        （2）促进剂：在防老剂多年深耕，全球领先的基础上，拓展促进剂业务。促进剂项目涉及各产品均已突破核心技术、实现绿色发展，自主研发突破的“绿色、环保”关键核心技术，符合国家及行业的发展趋势，将替代落后产能，高含量的技术门槛将带来显著的竞争优势。新工艺引领行业绿色转型发展，三废排放大幅降低。
        （3）塑料添加剂：8月26日，中化国际完成对江苏富比亚化学品有限公司的收购，标志着公司正式进军塑料添加剂业务。富比亚的主要产品包括光稳定剂、紫外线吸收剂、特种阻燃剂等。发展塑料添加剂产业将形成明显的“补链、强链”效用，增强协同、深入消费端应用、提高研发创新水平与抗周期、抗风险能力，同时塑料添加剂业务与中化国际正在发展的工程塑料、环氧树脂等多个新材料业务高度协同，有利于中化国际充分发挥材料科学产业协同优势，实现供应链自主可控，形成材料科学产业一体化解决方案。`
      },
      {
        question:'公司聚合物添加剂在海外是否有相关布局？',
        right:'海外布局方面，圣奥化学泰国2.5万吨橡胶防老剂6PPD项目正在建设中，由于泰国的防疫形势严峻，项目的施工进度受到影响，目前项目已经基本建成，正推进投产前的准备工作，预计2021年底前建成投产，但疫情的反复会带来较大的不确定性。'
      }
      
    ]
  },

  {
    name:'轻量化材料',
    answer:[
      {
        question:'公司可降解塑料目前有多大产能？',
        right:'尊敬的投资者您好，感谢您的提问。公司目前加快推进生物基可降解材料PHAs的布局，已与中国科学院天津工业技术研究所签署了合作框架协议，双方将合作开发拥有独立知识产权的PHAs生产菌种、生产工艺和PHAs产品改性技术等，目前各项开发工作进展顺利，后续双方将加快开展不同等级的放大试验，以获得更好的产品性能和有竞争力的成本，并将根据实际进展启动产业化落地工作。感谢您对公司的关注。'
      },
      // {
      //   question:'公司与北京蓝晶微生物合作的PHA产业化中试已经进行，请问公司的低成本PHA与国内主流的PBAT相比，成本谁高？性能相比优劣如何？目前这方面进展情况如何？产能有多少？',
      //   right:'尊敬的投资者您好，感谢您的提问。由于产能和技术所限，目前市场上PHA生产成本普遍高于PBAT等其他可降解塑料。公司正在研发低成本PHA技术。性能方面，与其他可降解塑料相比，PHA是完全生物基/生物可降解塑料，在自然环境下无需堆肥即可降解，且可在自然水体中完全降解。该项目目前正处于中试阶段，该阶段主要工作为数据采集、样本测试和工艺优化，目的是降低PHA的生产成本并提高性能。感谢您对公司的关注。'
      // },
      {
        question:'公司在2019年报中提到的2.4 万吨/年 ABS 改性材料项目目前已经开始工程建设。请问何时建成投产？投产以后将应用到哪些方面？',
        right:'尊敬的投资者您好，感谢您的提问。该项目属于改性塑料领域，在汽车工业、家用电器、医疗卫生、轨道交通、建筑工程等行业均有广泛应用，预计2021年10月建成投产。感谢您对公司的关注。'
      }
    ]
  },

];
export default data